import {
  useTailwindLgScreenMediaQuery,
  useTailwindMdScreenMediaQuery,
} from "@circle-react/hooks/useMediaQuery";
import { AllContent } from "./AllContent";
import { ContentHideable } from "./ContentHideable";

interface PaywallDescriptionProp {
  description?: string;
}

const getVariant = (isTablet: boolean, isDesktop: boolean) => {
  if (isDesktop) {
    return "desktop";
  }

  if (isTablet) {
    return "tablet";
  }

  return "mobile";
};

const MAXIMUM_LENGTH_VARIANTS = {
  desktop: 160,
  tablet: 250,
  mobile: 120,
};

export const PaywallDescription = ({ description }: PaywallDescriptionProp) => {
  const isTablet = useTailwindMdScreenMediaQuery();
  const isDesktop = useTailwindLgScreenMediaQuery();
  const variant = getVariant(isTablet, isDesktop);

  if (!description) {
    return null;
  }

  if (description.length <= MAXIMUM_LENGTH_VARIANTS[variant]) {
    return <AllContent description={description} />;
  }

  return (
    <>
      <ContentHideable
        description={description}
        className="hidden lg:block"
        shouldShowMoreInitialState
        maximumLength={MAXIMUM_LENGTH_VARIANTS.desktop}
      />
      <ContentHideable
        description={description}
        className="block lg:hidden"
        maximumLength={MAXIMUM_LENGTH_VARIANTS[variant]}
      />
    </>
  );
};
